import { render } from "./CreateAutoSystemClassification.vue?vue&type=template&id=bee5d628&scoped=true&ts=true"
import script from "./CreateAutoSystemClassification.vue?vue&type=script&lang=ts"
export * from "./CreateAutoSystemClassification.vue?vue&type=script&lang=ts"

import "./CreateAutoSystemClassification.vue?vue&type=style&index=0&id=bee5d628&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee5d628"]])

export default __exports__